import React from 'react'
import "./NavBar.css";
import {Link} from 'react-router-dom'
function NavBar() {

 
 

  return (
    
    <div className='navbar'>
      <img className='logo' src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Netflix_2015_logo.svg/1920px-Netflix_2015_logo.svg.png" alt="" />
      <img className='avatar' src="https://i.pinimg.com/originals/0d/dc/ca/0ddccae723d85a703b798a5e682c23c1.png" alt="" />
     
      <div className="nav-opts ">
       
       <Link  to="/" className="btn nav-btn"  >
         Home
       </Link>
       <Link  to="/movies" className="btn nav-btn"  >
       Movies 
       </Link>
       <Link to="/tvshows" className="btn nav-btn" >
        Tv Shows
       </Link>
     </div>
   
    </div>

  )
}

export default NavBar